

// import { useState } from "react";
// import Sidebar from "./components/Sidebar";
// import Header from "./components/Header";
// import Dashboard from "./pages/Dashboard";           // fintech overview
// import SuperAdminTable from "./components/SuperAdminTable";
// import OrganizationTable from "./components/OrganizationTable"; 
// import TransactionsTable from "./components/TransactionsTable";
// function App() {
//   const [activePage, setActivePage] = useState("Overview");

//   return (
//     <div className="flex h-screen overflow-hidden bg-bg-black text-text-white">
//       <Sidebar 
//         active={activePage} 
//         onItemClick={setActivePage} 
//       />

//       <div className="flex-1 flex flex-col overflow-hidden">
//         <Header name="Admin" />

//         <main className="flex-1 overflow-y-auto">
//           {activePage === "Overview" && <Dashboard />}
          
//           {activePage === "Super Admin" && <SuperAdminTable />}
//           {activePage === "Organization" && <OrganizationTable />}
//           {activePage !== "Overview" && activePage !== "Super Admin" && (
//             <div className="flex items-center justify-center h-full text-text-muted text-xl">
//               Page under construction: {activePage}
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default App;



// // src/App.jsx
// import { useState } from "react";
// import Sidebar from "./components/Sidebar";
// import Header from "./components/Header";
// import Dashboard from "./pages/Dashboard";
// import SuperAdminTable from "./components/SuperAdminTable";
// import OrganizationTable from "./components/OrganizationTable";
// import TransactionsTable from "./components/TransactionsTable";
// import Settings from "./pages/Settings";          // ← Make sure this import exists

// function App() {
//   const [activePage, setActivePage] = useState("Overview");

//   return (
//     <div className="flex h-screen overflow-hidden bg-bg-black text-text-white">
//       <Sidebar 
//         active={activePage} 
//         onItemClick={setActivePage}           // ← this passes setActivePage
//       />

//       <div className="flex-1 flex flex-col overflow-hidden">
//         <Header name="Admin" />

//         <main className="flex-1 overflow-y-auto">
//           {activePage === "Overview" && <Dashboard />}
//           {activePage === "Super Admin" && <SuperAdminTable />}
//           {activePage === "Organization" && <OrganizationTable />}
//           {activePage === "Transactions" && <TransactionsTable />}
//           {activePage === "Settings" && <Settings />}           {/* ← Add this line */}

//           {/* Fallback for unknown pages */}
//           {activePage !== "Overview" &&
//            activePage !== "Super Admin" &&
//            activePage !== "Organization" &&
//            activePage !== "Transactions" &&
//            activePage !== "Settings" && (
//             <div className="flex items-center justify-center h-full text-text-muted text-xl">
//              Comming soon {activePage}
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default App;

// // src/App.jsx
// import { useState, useEffect } from "react";
// import Sidebar from "./components/Sidebar";
// import Header from "./components/Header";
// import Dashboard from "./pages/Dashboard";
// import SuperAdminTable from "./components/SuperAdminTable";
// import OrganizationTable from "./components/OrganizationTable";
// import TransactionsTable from "./components/TransactionsTable";
// import Settings from "./pages/Settings";
// import Login from "./pages/Login";   // ← New import

// function App() {
//   const [activePage, setActivePage] = useState("Overview");
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState("Admin");

//   // Check login status on mount
//   useEffect(() => {
//     const loggedIn = localStorage.getItem("isLoggedIn") === "true";
//     const savedName = localStorage.getItem("userName");

//     if (loggedIn) {
//       setIsLoggedIn(true);
//       if (savedName) setUserName(savedName);
//     }
//   }, []);

//   const handleLoginSuccess = () => {
//     setIsLoggedIn(true);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("isLoggedIn");
//     localStorage.removeItem("userName");
//     setIsLoggedIn(false);
//     setActivePage("Overview");
//   };

//   // If not logged in → show Login page
//   if (!isLoggedIn) {
//     return <Login onLoginSuccess={handleLoginSuccess} />;
//   }

//   // Main authenticated layout
//   return (
//     <div className="flex h-screen overflow-hidden bg-bg-black text-text-white">
//       <Sidebar 
//         active={activePage} 
//         onItemClick={setActivePage}
//       />

//       <div className="flex-1 flex flex-col overflow-hidden">
//         {/* <Header name={userName} /> */}
//         <Header 
//   name={userName} 
//   onLogout={handleLogout} 
// />

//         <main className="flex-1 overflow-y-auto">
//           {activePage === "Overview" && <Dashboard />}
//           {activePage === "Super Admin" && <SuperAdminTable />}
//           {activePage === "Organization" && <OrganizationTable />}
//           {activePage === "Transactions" && <TransactionsTable />}
//           {activePage === "Settings" && <Settings />}

//           {/* Fallback */}
//           {activePage !== "Overview" &&
//            activePage !== "Super Admin" &&
//            activePage !== "Organization" &&
//            activePage !== "Transactions" &&
//            activePage !== "Settings" && (
//             <div className="flex items-center justify-center h-full text-text-muted text-xl">
//               Coming soon: {activePage}
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default App;


// // src/App.jsx
// import { useState, useEffect } from "react";
// import Sidebar from "./components/Sidebar";
// import Header from "./components/Header";
// import Dashboard from "./pages/Dashboard";
// import SuperAdminTable from "./components/SuperAdminTable";
// import OrganizationTable from "./components/OrganizationTable";
// import TransactionsTable from "./components/TransactionsTable";
// import Settings from "./pages/Settings";
// import Auth from "./pages/Auth";        // ← Combined Login + Register

// function App() {
//   const [activePage, setActivePage] = useState("Overview");
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userName, setUserName] = useState("Admin");

//   // Check login status on mount
//   useEffect(() => {
//     const loggedIn = localStorage.getItem("isLoggedIn") === "true";
//     const savedName = localStorage.getItem("userName");

//     if (loggedIn) {
//       setIsLoggedIn(true);
//       if (savedName) setUserName(savedName);
//     }
//   }, []);

//   const handleLoginSuccess = () => {
//     setIsLoggedIn(true);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("isLoggedIn");
//     localStorage.removeItem("userName");
//     setIsLoggedIn(false);
//     setActivePage("Overview");
//   };

//   // If not logged in → show Auth page (Login + Register tabs)
//   if (!isLoggedIn) {
//     return <Auth onLoginSuccess={handleLoginSuccess} />;
//   }

//   // Main authenticated layout
//   return (
//     <div className="flex h-screen overflow-hidden bg-bg-black text-text-white">
//       <Sidebar 
//         active={activePage} 
//         onItemClick={setActivePage}
//       />

//       <div className="flex-1 flex flex-col overflow-hidden">
//         <Header 
//           name={userName} 
//           onLogout={handleLogout} 
//         />

//         <main className="flex-1 overflow-y-auto">
//           {activePage === "Overview" && <Dashboard />}
//           {activePage === "Super Admin" && <SuperAdminTable />}
//           {activePage === "Organization" && <OrganizationTable />}
//           {activePage === "Transactions" && <TransactionsTable />}
//           {activePage === "Settings" && <Settings />}

//           {/* Fallback for unknown pages */}
//           {activePage !== "Overview" &&
//            activePage !== "Super Admin" &&
//            activePage !== "Organization" &&
//            activePage !== "Transactions" &&
//            activePage !== "Settings" && (
//             <div className="flex items-center justify-center h-full text-text-muted text-xl">
//               Coming soon: {activePage}
//             </div>
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default App;

// src/App.jsx
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AdminRoutes from "./routes/AdminRoutes";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AdminRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}